import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home.vue'
import Login from '../views/login.vue'
import Register from '../views/register.vue'
import DeviceList from '../views/device-list.vue'
import DeviceInfo from '../views/device-info.vue'
import Location from '../views/location.vue'
import AIDiagnosis from '../views/ai-diagnosis.vue'
import WebhViewAi from '../views/webViewAi.vue'
import Chat from '../views/chat.vue'
import Statistics from '../views/statistics.vue'
import PoseDetection from '../views/pose-detection.vue'
import Hospitals from '../views/hospitals.vue'
import Profile from '../views/profile.vue'
import HealthRecord from '../views/health-record.vue'
import HealthRecordList from '../views/health-record-list.vue'
import HealthRecordDetail from '../views/health-record-detail.vue'
import CESI from '../views/cesi.vue'
import Playback from '../views/playback.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/register',
    name: 'Register',
    component: Register
  },
  {
    path: '/device-list',
    name: 'DeviceList',
    component: DeviceList,
    meta: { requiresAuth: true }
  },
  {
    path: '/device-info',
    name: 'DeviceInfo',
    component: DeviceInfo,
    meta: { requiresAuth: true }
  },
  {
    path: '/location',
    name: 'Location',
    component: Location,
    meta: { requiresAuth: true }
  },
  {
    path: '/ai-diagnosis',
    name: 'AIDiagnosis',
    component: AIDiagnosis,
    meta: { requiresAuth: true }
  },
  {
    path: '/WebhViewAi',
    name: 'WebhViewAi',
    component: WebhViewAi,
    meta: { requiresAuth: true }
  },
  {
    path: '/chat',
    name: 'Chat',
    component: Chat,
    meta: { requiresAuth: true }
  },
  {
    path: '/statistics',
    name: 'Statistics',
    component: Statistics,
    meta: { requiresAuth: true }
  },
  {
    path: '/pose-detection',
    name: 'PoseDetection',
    component: PoseDetection,
    meta: { requiresAuth: true }
  },
  {
    path: '/hospitals',
    name: 'Hospitals',
    component: Hospitals,
    meta: { requiresAuth: true }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    meta: { requiresAuth: true }
  },
  {
    path: '/health-record',
    name: 'HealthRecord',
    component: HealthRecord,
    meta: { requiresAuth: true }
  },
  {
    path: '/health-record-list',
    name: 'HealthRecordList',
    component: HealthRecordList,
    meta: { requiresAuth: true }
  },
  {
    path: '/health-record-detail',
    name: 'HealthRecordDetail',
    component: HealthRecordDetail,
    meta: { requiresAuth: true }
  },
  {
    path: '/CESI',
    name: 'CESI',
    component: CESI,
    meta: { requiresAuth: true }
  },
  {
    path: '/Playback',
    name: 'Playback',
    component: Playback,
    meta: { requiresAuth: true }
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

// 全局导航守卫
router.beforeEach((to, from, next) => {
  // 开发环境下，暂时允许访问所有页面
  if (process.env.NODE_ENV === 'development') {
    next()
    return
  }
  // 获取 token
  const token = localStorage.getItem('token')
  
  // 如果访问登录或注册页面，直接放行
  if (to.path === '/login' || to.path === '/register') {
    // 如果已登录且要访问登录页，重定向到首页
    if (token && to.path === '/login') {
      next('/home')
      return
    }
    next()
    return
  }
  
  // 如果路由需要认证但没有 token，重定向到登录页
  // if (to.matched.some(record => record.meta.requiresAuth) && !token) {
  //   next('/login')
  //   return
  // }
  
  // 有 token，放行
  next()
})

export default router 